import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {createApiResponseParser} from "../../api/api-response-parser.util";
import {ServiceParams, ServiceResponseSchema} from "./service.schema";

@Injectable({ providedIn: 'root' })

export class ServiceApi {
  readonly #http = inject(HttpClient);
  readonly #baseUrl = environment.url;

  getServices() {
    return this.#http
      .get(`${this.#baseUrl}/our-services`, {
        params: {...ServiceParams},
      })
      .pipe(map(createApiResponseParser(ServiceResponseSchema)));
  }
}
